import request from '../utils/request'
export function logoSearch (data) {
  return request({
    url: `/landmark/logo/search`,
    method: 'GET',
    params: data
  })
}
//初始化数据
export function searchInit (data) {
  return request({
    url: `/landmark/product/search/init`,
    method: 'GET',
    params: data
  })
}
//更多
export function moreList (data) {
  return request({
    url: `/landmark/product/search/list`,
    method: 'GET',
    params: data
  })
}
// 详情
export function searchDetail (data) {
  return request({
    url: `/landmark/product/search/detail`,
    method: 'GET',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/landmark-user/api/query.js